const Spinner = ({ color, padding }) => {
  return (
    <div class="text-center" style={{ "padding-top": padding }}>
      <div class="spinner-border" role="status" style={{ color: color }}></div>
    </div>
  );
};
export default Spinner;
